module.exports = __webpack_public_path__ + "static/media/arrowDownWhite.1872d33e.svg";